import PropTypes from 'prop-types';
import React, { memo } from 'react';
import Grid from '@material-ui/core/Grid';
import { lookupsJson } from '@ourbranch/lookups';
import { Form } from 'formik';

import CollapsibleCard from 'core/components/collapsible-card';
import { FormField } from 'core/components/form';
import { Label } from 'core/components/label';
import RemoveButton from 'core/components/remove-button';

import useStyles from '../../people/person.styles';

function FarmInterestedParty({
  associatedEntityOptions,
  index,
  fieldName,
  item,
  removeFromList,
  onRemove,
  initialFold,
  onFold,
  disabled
}) {
  const classes = useStyles();

  return (
    <CollapsibleCard
      content={
        <Label
          type="infoSubtitle"
          style={{
            display: 'inline',
            marginRight: 8
          }}
        >{`${item.name}`}</Label>
      }
      contentRight={!item.isPrimary && <RemoveButton mode="big" onClick={() => onRemove(index, removeFromList)} />}
      initialOpen={initialFold}
      onChange={(val) => onFold(index, val)}
    >
      <Form disabled={disabled} className={classes.container}>
        <Grid key="container" container justifyContent="space-around" alignItems="center" spacing={4}>
          <FormField
            mode="light"
            name={`${fieldName}.relationship`}
            id={`${fieldName}.relationship`}
            label="Relationship"
            type="select"
            options={lookupsJson.farm.farmInterestedPartyTypes}
            xs={6}
            permissions={{ isLicensedAction: false }}
          />
          <FormField
            mode="light"
            name={`${fieldName}.name`}
            id={`${fieldName}.name`}
            label="Name or Company"
            type="string"
            xs={6}
            permissions={{ isLicensedAction: false }}
          />
          <FormField
            mode="light"
            name={`${fieldName}.address.address`}
            id={`${fieldName}.address.address`}
            label="Address"
            type="address"
            xs={8}
            permissions={{ isLicensedAction: false }}
          />
          <FormField
            mode="light"
            name={`${fieldName}.address.address2`}
            id={`${fieldName}.address.address2`}
            label="Address 2"
            type="string"
            optional
            xs={4}
            permissions={{ isLicensedAction: false }}
          />
          <FormField
            mode="light"
            name={`${fieldName}.address.city`}
            id={`${fieldName}.address.city`}
            label="City"
            type="string"
            optional
            xs={4}
            permissions={{ isLicensedAction: false }}
          />
          <FormField
            mode="light"
            name={`${fieldName}.address.state`}
            id={`${fieldName}.address.state`}
            label="State"
            type="state"
            xs={4}
            permissions={{ isLicensedAction: false }}
          />
          <FormField
            mode="light"
            name={`${fieldName}.address.zip`}
            id={`${fieldName}.address.zip`}
            label="Zip code"
            type="string"
            optional
            xs={4}
            permissions={{ isLicensedAction: false }}
          />
          <FormField
            mode="light"
            name="email"
            id="email"
            label="Email"
            type="string"
            placeholder="contact@example.com"
            xs={12}
            permissions={{ isLicensedAction: false }}
          />
          <FormField
            mode="light"
            name={`${fieldName}.associatedEntities`}
            id={`${fieldName}.associatedEntities`}
            label="Associated Entity"
            type="select"
            options={associatedEntityOptions}
            xs={12}
            permissions={{ isLicensedAction: false }}
          />
        </Grid>
      </Form>
    </CollapsibleCard>
  );
}

FarmInterestedParty.propTypes = {
  associatedEntityOptions: PropTypes.array.isRequired,
  index: PropTypes.number.isRequired,
  fieldId: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  item: PropTypes.shape({
    isPrimary: PropTypes.bool,
    name: PropTypes.string.isRequired,
    relationship: PropTypes.string.isRequired,
    address: PropTypes.object,
    associatedEntity: PropTypes.string
  }).isRequired,
  onRemove: PropTypes.func.isRequired,
  removeFromList: PropTypes.func.isRequired,
  initialFold: PropTypes.bool.isRequired,
  onFold: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

FarmInterestedParty.defaultProps = {
  disabled: false
};

export default memo(FarmInterestedParty);
